/**
 * Created by mmichieli on 13/02/2017.
 */
import { ReferentielModel } from './referentiel.model';

export class SubtitleContentModel {
  public id: number = null;
  public isDefault = false;
  public materialNumber: number;
  public languageId: number;
  public contentId: number;
  public stateId: number;
  public typeId: number;
  public origin: string = null;
  public localisation: string = null;
  public availabilityDate: string = null;
  public statusId: number;

  public languageLabel: string = null;
  public contentLabel: string = null;
  public stateLabel: string = null;
  public typeLabel: string = null;
  public statusLabel: string = null;

  public status: ReferentielModel = new ReferentielModel();
  public uuid: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
